import React from 'react';

import CoverScreen from './CoverScreen';

export default (props: any) => <CoverScreen {...props} back={true} />;
